import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {NO_SEND_HEADER} from '../utils/constants/context';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(NO_SEND_HEADER)) return next(req);

  const authService = inject(AuthService);
  const token = authService.auth()?.Token;
  const newReq = req.clone({
    headers: req.headers
      .append('Authorization', `Bearer ${token}`)
      .append('Accept-Language', 'es-AR')
  });

  return next(newReq);
};
